import { memo } from 'react';
import { IconProps } from './iconType';

export const ArrowBottomBgIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none">
      <circle cx="12.5" cy="12" r="11.5" stroke={color} />
      <path
        d="M12.4998 13.0734L17.0372 8.53613L18.3335 9.83249L12.4998 15.6662L6.66626 9.83249L7.96262 8.53613L12.4998 13.0734Z"
        fill={color}
      />
    </svg>
  );
});

ArrowBottomBgIcon.displayName = 'ArrowBottomBgIcon';
